export var actionButtonRenderMap = {
  'showcase.quickclick': false,
  'showcase.quickclick.button': true
};
export var actionTypesRenderMap = ['add_item_to_cart', 'view_cart'];
export var useInViewConfig = {
  delay: 1000,
  threshold: 0.5,
  triggerOnce: true
};